import Component from "../../classes/Component";
import {$events} from "../../helpers/events";
import {$dom} from "../../helpers/dom";

const rootSelector = '.js-landing-lang-switch';
const btnContentSelector = '[data-lang-switch-button-content]';
const optionSelector = '[data-lang-switch-option]';
const optionContentSelector = '[data-lang-switch-option-content]';

export default function () {

	return new Component({
		name: 'langSwitch',
		requiredTargets: rootSelector,
		onInit() {
            this.handleChoose = (e) => {
                const currentRoot = e.target.closest(rootSelector);
                const currentOption = e.target.closest(optionSelector);
                if (!currentRoot || !currentOption) return;

                const currentOptionContent = $dom.get(optionContentSelector, currentOption);
                const currentBtnContent = $dom.get(btnContentSelector, currentRoot);
                if (!currentOptionContent || !currentBtnContent) return;

                $dom.text(currentBtnContent, $dom.text(currentOptionContent))
            }

		    $events.delegate
                .on('click', optionSelector, this.handleChoose)
        },
		onDestroy() {
            $events.delegate
                .off('click', optionSelector, this.handleChoose)
        }
	})
}
